import React from 'react'
import { Card, Row, Col } from 'react-bootstrap'
import SketchfabSingleModel from '../common/SketchfabSingleModel'

const GameModeling = () => {
  return (
    <>
        <Card className='no-border rounded-0 game-modeling container'>
            <Card className='no-border rounded-0' >
                <Card className='text-center no-border rounded-0 game-modeling-top-section'>
                    <Card.Body className='game-modeling-chinese-fort-top pb-md-5 container'>
                        <Card.Title className='game-modeling-title'>Game Modeling</Card.Title>
                        <Card.Text className='game-modeling-top-text'>
                        3D game engines such as Unity and Unreal Engine bring unique requirements for 3D modeling, from poly - count and performance requirements to real - time rendering and “baked” lighting techniques. Whether modeling from real - life reference images or creative fa ntasy designs, our artists are expert in creating high quality 3D game assets.
                        </Card.Text>
                    </Card.Body>
                    <Card.Img src={process.env.PUBLIC_URL + "assets/game/images/chinese_gate.jpg"} alt="Chinese Fort" />
                    <Card.ImgOverlay className='chinese-fort-card-image-overlay'>
                        <Card.Subtitle className="game-modeling-subtitle py-md-4">Chinese Fortress Gate</Card.Subtitle>
                        <Card.Text className='game-modeling-text'>
                        Created for virtual production video shot in Unreal Engine.
                        </Card.Text>
                    </Card.ImgOverlay>
                </Card>
            {/* </Card>
            <Card className='no-border rounded-0 container' > */}
                <Card className='no-border rounded-0 text-center'>
                    <Card.Body className='game-modelling-3d-assets-body'>
                        <Card.Title className='game-modeling-3d-assets py-md-5'>3D Game Assets</Card.Title>
                        <Row>
                            <Col md={2}></Col>
                            <Col md={8}>
                                <div className="scorpio-modeling-section">
                                    <SketchfabSingleModel  modelId="e92de698b2ee433ab4675dfbf35ed1e2" />
                                    {/* <Card.Img className='scorpio-modeling' src={process.env.PUBLIC_URL + "assets/game/images/scorpio.png"} alt="3D Game assets" /> */}
                                </div>
                            </Col>
                            <Col md={2}></Col>
                        </Row>
                    </Card.Body>
                </Card>
                {/* <Card className='no-border rounded-0'> */}
                    <Row  xs={5} md={5}  className=''>
                        
                        <Col className='game-assets-grid'>
                            <Card className='no-border rounded-0'>
                                <Card.Img className='game-images' src={process.env.PUBLIC_URL + "assets/game/images/game_001.png"} alt="" />
                            </Card>
                        </Col>
                        <Col className='game-assets-grid'>
                            <Card className='no-border rounded-0'>
                                <Card.Img className='game-images' src={process.env.PUBLIC_URL + "assets/game/images/game_002.png"} alt="" />
                            </Card>
                        </Col>
                        <Col className='game-assets-grid'>
                            <Card className='no-border rounded-0'>
                                <Card.Img className='game-images' src={process.env.PUBLIC_URL + "assets/game/images/game_003.png"} alt="" />
                            </Card>
                        </Col>
                        <Col className='game-assets-grid'>
                            <Card className='no-border rounded-0'>
                                <Card.Img className='game-images' src={process.env.PUBLIC_URL + "assets/game/images/game_004.png"} alt="" />
                            </Card>
                        </Col>
                        <Col className='game-assets-grid'>
                            <Card className='no-border rounded-0'>
                                <Card.Img className='game-images' src={process.env.PUBLIC_URL + "assets/game/images/game_005.png"} alt="" />
                            </Card>
                        </Col>
                        
                    {/* </Row>
                    <Row> */}
                        
                        <Col className='game-assets-grid'>
                            <Card className='no-border rounded-0'>
                                <Card.Img className='game-images' src={process.env.PUBLIC_URL + "assets/game/images/game_006.png"} alt="" />
                            </Card>
                        </Col>
                        <Col className='game-assets-grid'>
                            <Card className='no-border rounded-0'>
                                <Card.Img className='game-images' src={process.env.PUBLIC_URL + "assets/game/images/game_007.png"} alt="" />
                            </Card>
                        </Col>
                        <Col className='game-assets-grid'>
                            <Card className='no-border rounded-0'>
                                <Card.Img className='game-images' src={process.env.PUBLIC_URL + "assets/game/images/game_008.png"} alt="" />
                            </Card>
                        </Col>
                        <Col className='game-assets-grid'>
                            <Card className='no-border rounded-0'>
                                <Card.Img className='game-images' src={process.env.PUBLIC_URL + "assets/game/images/game_009.png"} alt="" />
                            </Card>
                        </Col>
                        <Col className='game-assets-grid'>
                            <Card className='no-border rounded-0'>
                                <Card.Img className='game-images' src={process.env.PUBLIC_URL + "assets/game/images/game_010.png"} alt="" />
                            </Card>
                        </Col>
                        
                    </Row>
                {/* </Card> */}
            </Card>
        </Card>
    </>
  )
}

export default GameModeling
